var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravelInsuranceButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "4.43rem",
    viewBox: "0 0 57.924 57.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M95.334,182.244a1.133,1.133,0,1,0-.8.331A1.14,1.14,0,0,0,95.334,182.244Zm0,0",
    transform: "translate(-82.836 -159.913)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M6.087,441.449.331,447.2a1.131,1.131,0,1,0,1.6,1.6l5.756-5.756a1.131,1.131,0,0,0-1.6-1.6Zm0,0",
    transform: "translate(0 -391.212)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M1.131,230.676a1.127,1.127,0,0,0,.8-.331l6.325-6.324a1.132,1.132,0,0,0-1.6-1.6L.332,228.744a1.132,1.132,0,0,0,.8,1.932Zm0,0",
    transform: "translate(0 -196.963)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M224.767,467.863,222,470.63a1.131,1.131,0,1,0,1.6,1.6l2.767-2.767a1.131,1.131,0,1,0-1.6-1.6Zm0,0",
    transform: "translate(-196.59 -414.638)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M57.371,30.723,44.856,23.286l8.477-8.476A15.71,15.71,0,0,0,57.71,1.143a1.131,1.131,0,0,0-.93-.93A15.709,15.709,0,0,0,43.113,4.592L35.107,12.6l-3.634-.346A3.474,3.474,0,0,0,25.705,8.74l-2.7,2.7L19.417,11.1A3.475,3.475,0,0,0,13.66,7.552l-2.739,2.739L6.283,9.849a1.133,1.133,0,0,0-.907.327L.332,15.22a1.132,1.132,0,0,0,.277,1.8l6.55,3.416A1.131,1.131,0,1,0,8.2,18.433l-5.182-2.7L6.6,12.152l26.433,2.521L22.05,25.655l-5.794-3.022a1.131,1.131,0,0,0-1.046,2.006l5.163,2.693L18.6,29.108a33.8,33.8,0,0,0-4.634,5.778l-9.839.181a1.131,1.131,0,0,0-.779.331l-2.63,2.63A1.132,1.132,0,0,0,1.152,39.9l9.086,3.063a33.974,33.974,0,0,0-1.05,4.471,1.131,1.131,0,0,0,1.3,1.3,33.974,33.974,0,0,0,4.471-1.05l3.064,9.086a1.131,1.131,0,0,0,.814.74,1.142,1.142,0,0,0,.258.03,1.13,1.13,0,0,0,.8-.331l2.63-2.63a1.132,1.132,0,0,0,.331-.78l.171-9.832A33.684,33.684,0,0,0,28,40.116,21.349,21.349,0,0,0,42.53,57.866a1.132,1.132,0,0,0,.709,0A21.354,21.354,0,0,0,57.924,37.554V31.7a1.131,1.131,0,0,0-.553-.973ZM27.305,10.341a1.212,1.212,0,0,1,1.746,1.68l-3.128-.3ZM15.26,9.153a1.213,1.213,0,1,1,1.715,1.715h0l-3.131-.3ZM3.6,38.339,4.62,37.321l8.013-.148a33.28,33.28,0,0,0-1.658,3.652ZM20.6,53.3l-1.018,1.017L17.1,46.947a33.243,33.243,0,0,0,3.644-1.653Zm.772-10.972a1.063,1.063,0,0,0-.1.06,31.171,31.171,0,0,1-9.548,3.8A31.184,31.184,0,0,1,20.2,30.708L44.713,6.192A13.446,13.446,0,0,1,55.589,2.335,13.446,13.446,0,0,1,51.732,13.21l-9.126,9.126a1.134,1.134,0,0,0-.3.123L28.4,30.723a1.132,1.132,0,0,0-.554.973v5.4l-.63.63a31.472,31.472,0,0,1-5.841,4.6Zm34.287-4.778A19.093,19.093,0,0,1,42.884,55.6,19.093,19.093,0,0,1,30.109,37.659a1.129,1.129,0,0,0,0-.212V32.339l12.777-7.591,12.777,7.591Zm0,0",
    transform: "translate(0 0)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M296.062,243.8l-9.383,5.575a1.132,1.132,0,0,0-.554.973v3.284a16.859,16.859,0,0,0,10.059,15.432,1.13,1.13,0,0,0,.911,0,16.859,16.859,0,0,0,10.059-15.432v-3.284a1.132,1.132,0,0,0-.553-.973l-9.383-5.575a1.131,1.131,0,0,0-1.156,0Zm8.829,7.191v2.641a14.6,14.6,0,0,1-8.252,13.151,14.6,14.6,0,0,1-8.252-13.151V250.99l8.252-4.9Zm0,0",
    transform: "translate(-253.755 -216.076)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M351.6,326.049a1.131,1.131,0,0,0-1.6,1.6l1.842,1.842a1.131,1.131,0,0,0,1.6,0l4.483-4.483a1.131,1.131,0,0,0-1.6-1.6l-3.683,3.683Zm0,0",
    transform: "translate(-310.109 -286.526)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M338.248,76.211a1.128,1.128,0,0,0,.8-.331l10.323-10.323a1.131,1.131,0,0,0-1.6-1.6L337.448,74.279a1.132,1.132,0,0,0,.8,1.932Zm0,0",
    transform: "translate(-298.978 -56.427)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M309.963,185.423a1.132,1.132,0,1,0-.8-.331A1.145,1.145,0,0,0,309.963,185.423Zm0,0",
    transform: "translate(-273.893 -162.438)",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelInsuranceButtonIcon);
export default __webpack_public_path__ + "static/media/travel-insurance-button-icon.007da67431a0ecadcd790cb31a93e395.svg";
export { ForwardRef as ReactComponent };